import { Component } from "react";
import LangContext from "../../../contexts/LangContext";
import { translate } from "../../../helper";
import { LoaderSearch } from "../Loader";
import "./index.css";

class SearchForm extends Component {
  static contextType = LangContext;
  constructor(props) {
    super(props);

    this.jsonData = null;
    this.handleSelectProvince = this.handleSelectProvince.bind(this);
    this.handleSelectDistrict = this.handleSelectDistrict.bind(this);
    this.handleSelectRegion = this.handleSelectRegion.bind(this);
  }

  handleSelectProvince(el) {
    this.props.handleSearch(el.target.value, "province");
  }

  handleSelectDistrict(el) {
    this.props.handleSearch(el.target.value, "district");
  }

  handleSelectRegion(el) {
    this.props.handleSearch(el.target.value, "region");
  }

  componentDidMount() {
    this.lang = this.context.lang;
  }

  render() {
    this.lang = this.context.lang;
    if (this.props.provinces.length === 0) {
      <LoaderSearch />;
    }

    let { province, district, region } = this.props.searchParam;

    let pathname = window.location.pathname;
    let paths = [];
    if (pathname !== "/result/") {
      paths = pathname.split("/");
    }

    if (!province && paths.length > 2) {
      province = paths[2];
    }
    if (!district && paths.length > 3) {
      district = paths[3];
    }
    if (!region && paths.length > 4) {
      region = paths[4];
    }

    const selectedProvince = this.props.provinces.find((p) => String(p.id) === String(province));

    let allDistricts = [];
    if (!selectedProvince) {
      this.props.provinces.forEach((p) => {
        allDistricts = allDistricts.concat(p.districts);
      });
    }

    const districts = (selectedProvince && selectedProvince.districts) || allDistricts;

    const selectedDistrictFromProvince = selectedProvince ? selectedProvince.districts.find((d) => String(d.id) === String(district)) : null;
    const selectedDistrict = selectedDistrictFromProvince || allDistricts.find((d) => String(d.id) === String(district)) || null;

    let allRegions = [];
    if (!selectedDistrict) {
      this.props.provinces.forEach((p) => {
        p.districts.forEach((d) => {
          allRegions = allRegions.concat(d.regions.filter((r) => r.rtype === "federal").map((r) => ({ ...r, district: d })));
        });
      });
    }
    const regions = (selectedDistrict && selectedDistrict.regions.filter((r) => r.rtype === "federal").map((r) => ({ ...r, district: selectedDistrict }))) || allRegions;
    const selectedRegionObj = regions.find((r) => String(parseFloat(r.id).toFixed(0)) === String(parseFloat(region).toFixed(0)));
    const selectedRegionValue = region ? `${(selectedRegionObj && selectedRegionObj.district && selectedRegionObj.district.id) || district || ""}-${region}` : "";

    return (
      <div className="sh-search-section">
        <div className="sh-overlay">
          <div className="stepper-search-container">
            {/* Stepper Header */}
            <div className="stepper-header-row">
              <div className={`stepper-step ${province ? "active" : ""}`}>
                <div className="stepper-circle">1</div>
                <span className="stepper-label">{translate("select_province", this.lang)}</span>
              </div>
              <div className="stepper-line"></div>
              <div className={`stepper-step ${district ? 'active' : ''}`}>
                <div className="stepper-circle">2</div>
                <span className="stepper-label">{translate("select_district", this.lang)}</span>
              </div>
              <div className="stepper-line"></div>
              <div className={`stepper-step ${region ? 'active' : ''}`}>
                <div className="stepper-circle">3</div>
                <span className="stepper-label">{translate("select_region", this.lang)}</span>
              </div>
            </div>

            {/* Dropdown Row */}
            <form>
              <div className="stepper-dropdown-row">
                <div className="stepper-dropdown-group">
                  {/* <label htmlFor="sh-search-province" className="stepper-dropdown-label">
                    {translate("select_province", this.lang)}
                  </label> */}
                  <div className="stepper-select-wrapper">
                    <select 
                      id="sh-search-province" 
                      className="stepper-clean-dropdown" 
                      value={province || ""} 
                      onChange={this.handleSelectProvince}
                    >
                      <option value="">{translate("select_province", this.lang)}</option>
                      {this.props.provinces.map((p, i) => (
                        <option value={p.id} key={i}>
                          {p["name_" + this.lang]}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="stepper-dropdown-group">
                  {/* <label htmlFor="sh-search-district" className="stepper-dropdown-label">
                    {translate("select_district", this.lang)}
                  </label> */}
                  <div className="stepper-select-wrapper">
                    <select 
                      id="sh-search-district" 
                      className="stepper-clean-dropdown" 
                      value={district || ""} 
                      onChange={this.handleSelectDistrict}
                    >
                      <option value="">{translate("select_district", this.lang)}</option>
                      {districts.map((d, i) => (
                        <option value={d.id} key={i}>
                          {d["name_" + this.lang]}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="stepper-dropdown-group">
                  {/* <label htmlFor="sh-search-region" className="stepper-dropdown-label">
                    {translate("select_region", this.lang)}
                  </label> */}
                  <div className="stepper-select-wrapper">
                    <select 
                      id="sh-search-region" 
                      className="stepper-clean-dropdown" 
                      value={selectedRegionValue} 
                      onChange={this.handleSelectRegion}
                    >
                      <option value="">{translate("select_region", this.lang)}</option>
                      {regions.map((r, i) => (
                        <option value={r.district.id + "-" + r.id} key={i}>
                          {r.district["name_" + this.lang]} - {r["name_" + this.lang]}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default SearchForm;
